import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import * as DiscoveryFlightsActions from '../actions/discovery-flights.actions';
import { PaymentService } from '../../services/payment.service';

@Injectable()
export class DiscoveryFlightsEffects {
  constructor(
    private actions$: Actions,
    private paymentService: PaymentService,
  ) {}

  // Load flight details
  loadFlightDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DiscoveryFlightsActions.loadFlightDetails),
      switchMap(({ flightSchoolId, flightId }) =>
        this.paymentService
          .getFlightProductDetails(flightSchoolId, flightId)
          .pipe(
            map((details) =>
              DiscoveryFlightsActions.loadFlightDetailsSuccess({
                flightDetails: details,
              }),
            ),
            catchError((error) =>
              of(
                DiscoveryFlightsActions.loadFlightDetailsFailure({
                  error: error.message || 'Failed to load flight details',
                }),
              ),
            ),
          ),
      ),
    ),
  );
}
